module.exports = __webpack_public_path__ + "9df8ba3b216cc3a1bd1b0a6a82902a8a.svg";